export enum PaymentOptionEnum {
    ACCOUNT = 'ACCOUNT',
    THIRD_PARTY = 'THIRD_PARTY',
    COLLECT = 'COLLECT'
}
